import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import themeReducer from './themeSlice';
import authReducer from './authSlice';
import userReducer from './Slices/userSlice';
import marketReducer from './Slices/marketSlice';
import supportReducer from './Slices/supportSlice';
import spotTradingSlice from './Slices/spotTradingSlice';
import assetsReducer from './Slices/assetSlice';
import futuresTradingReducer from './Slices/FuturesTradingSlice';
import aiTradingReducer from './Slices/aiTradingSlice';
import notificationReducer from './Slices/NotificationSlice';
import referralReducer from './Slices/referralSlice';
import depositReducer from './Slices/depositSlice';
import withdrawReducer from './Slices/withdrawSlice';
import kycReducer from './Slices/kycSlice';
import PromotionReducer from './Slices/promotionSlice';
import PasswordReducer from './Slices/passwordResetSlice'
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'assets', 'spotTrading', 'futuresTrading', 'aiTrading'],
  blacklist: ['theme', 'auth', 'market', 'support'],
};

const rootReducer = combineReducers({
  theme: themeReducer,
  auth: authReducer,
  user: userReducer,
  market: marketReducer,
  support: supportReducer,
  spotTrading: spotTradingSlice,
  assets: assetsReducer,
  futures : futuresTradingReducer,
  aiTrading: aiTradingReducer,
  notifications: notificationReducer,
  deposit: depositReducer,
  referral: referralReducer,
  withdraw: withdrawReducer, 
  kyc : kycReducer,
  promotion: PromotionReducer,
  passwordReset: PasswordReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/PURGE'],
      },
    }),
});

export const persistor = persistStore(store);